import React, { useCallback, useEffect, useRef, useState } from 'react'
import SKUGroupCommonSelector from '../SKUGroupCommonSelector'
import { getEntityPriority } from '../../../services/services';
import { Button } from '@mui/material';
import { AddCircleOutlineOutlined } from '@material-ui/icons';
import { addMustBuyData, updateMustBuyUnit } from '../../../../../stateManagement/actions/manageCouponActions';
import MustBuySelected from './MustBuySelected';
import { useSelector } from 'react-redux';
import { INVALID, INVALID_EMPTY_DATA, INVALID_BATCHCODE_OVERLAPPING, labelMappings } from '../../../utils/utils';
import { openPopup } from '../../../../../stateManagement/actions/popupActions';
import { ConfirmationPopUp } from '../../../../../components/popup/confirmationPopUp';
import PeiceCaseSwitch from '../applicableSlab/PeiceCaseSwitch';
import { getMustBuyTabContent, validateMustBuy } from './service';
import { filterSelectedProductGroup, getHeadersList } from '../productSelection/service';
import { useCouponAlert } from '../../../context/CouponAlert';
import { currentMustBuyType } from '../../../types';

let INITIAL_STATE:Record<string,string | null | string[]> = { id: null }


function MustBuy() {
    const [loading, setLoading] = useState<boolean>(true);
    const [tabsList, setTabList] = useState<string[]>([]);
    const [currentMustBuy, setCurrentMustMuy] = useState<currentMustBuyType>({});
    const [selectorVisible, setSelectorVisible] = useState<boolean>(true);
    const {schemeProductBifurcationsList} = useSelector((state:any)=>state?.manageCoupons?.data);
    const { data:mustBuy,quantityUnit} = useSelector((state: any) => state.manageCoupons?.data?.mustBuy);

    const [selectorKey, setSelectorKey] = useState<number>(1); // Add a key state
    const [confirmationDetails , setConfirmationDetails] = useState<{message:string,open:boolean}>({message:'',open:false})
    const {showAlert} = useCouponAlert();
    
    const successMethodRef = useRef(()=>{});

    const handleSave = async (): Promise<void> => {
        const validMustBuyGrp = await filterSelectedProductGroup(currentMustBuy,tabsList);
        
        const response = validateMustBuy(validMustBuyGrp,tabsList);
        if (response === INVALID_EMPTY_DATA) {
            openPopup("Alert",labelMappings["EMPTY_DATA_IN_MUST_BUY"])
            return;
        }
        else if(response === INVALID_BATCHCODE_OVERLAPPING){
            openPopup("Alert", labelMappings["MUST_BUY_BATCHCODE_OVERLAPPING"])
            return;
        }
        else if (response === INVALID) {
            openPopup("Alert", labelMappings["MUST_BUY_OUT_OF_PRODUCT_SELECTION_RANGE"])
            return;
        }
        addMustBuyData(validMustBuyGrp);
        setSelectorVisible(false);
        setCurrentMustMuy(INITIAL_STATE);
    }

    const handleChange = (selectedItems: string[], entityName: string) => {
        // get filtered data after removing lowerPriority data
        const currentEntityPriority = getEntityPriority(entityName);
        
        let filteredData: Record<string,string | null | string[]>= { ...currentMustBuy };
        let isLowerPriorityRemoved:boolean = false;

        tabsList.forEach((tab:string) => {
            // higher value means lower priority
            if (getEntityPriority(tab) > currentEntityPriority &&  filteredData[tab] && Array.isArray(filteredData[tab]) && filteredData[tab]?.length! > 0 ) {
                filteredData[tab] = [];
                isLowerPriorityRemoved = true;
            } else if(currentMustBuy[tab] !== undefined) {
                filteredData[tab] = currentMustBuy[tab]!;
            }
        })

        if(isLowerPriorityRemoved){
            // showing appropriate conformation message
            const msg:string = labelMappings["TABS_LOWER_PRIORITY_DATA_RESET"]
            successMethodRef.current = ()=>{
                setCurrentMustMuy(() => ({ ...filteredData, [entityName]: selectedItems?.length > 0 ? selectedItems : [] }))            }
            setConfirmationDetails(()=>({message:msg,open:true}))            
        }
        else setCurrentMustMuy(() => ({ ...filteredData, [entityName]: selectedItems?.length > 0 ? selectedItems : [] }))


        
    }

    const getTabList = useCallback(async () => {
        setLoading(true);
        try {
            const tablist = await getHeadersList();
            setTabList(tablist);
            tablist.forEach((item: string) => {
                INITIAL_STATE[item] = []
            })
            INITIAL_STATE["min_qty"] = null;
            setCurrentMustMuy(INITIAL_STATE)
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [])


    const handleQuantityUnitChange = (val:string)=>{

        if(mustBuy.length > 0){
            showAlert(labelMappings["MUST_BUY_INVALID_UNIT_CHANGE"],'warning');
            return 
        }
        updateMustBuyUnit(val);
    }

    useEffect(() => {
        getTabList();
    }, [])
      
    useEffect(()=>{
        // this is used to create a rerender to SKUGroupCommonSelector 
        // because we want SKUGroupCommonSelector to show only values present in schemeProductBifurcationsList
        setSelectorKey((pre)=>pre+1);
    },[schemeProductBifurcationsList])

    return (
        <div className='must-buy-wrapper'>
            <div className="must-buy-header">
                <PeiceCaseSwitch onChange={handleQuantityUnitChange} value={quantityUnit}/>
                <Button className='sku-group-addmore-btn' onClick={()=>setSelectorVisible(true)} size='small' startIcon={<AddCircleOutlineOutlined />}>Add More</Button>
            </div>
            <div className="must-buy-content">
                {
                    selectorVisible &&
                    <SKUGroupCommonSelector
                        key={selectorKey} // used to create rerender
                        getTabContent={getMustBuyTabContent}
                        handleChange={handleChange}
                        tabsList={tabsList}
                        handleSave={handleSave}
                        loading={loading}
                        data={currentMustBuy}
                        multiple={true}
                    />
                }
            </div>
            <div className="must-buy-footer">
                <MustBuySelected tabsList={tabsList}/>
            </div>

            <ConfirmationPopUp
                message={confirmationDetails.message}
                openConfirmModal={confirmationDetails.open}
                setOpenConfirmModal={(val)=>setConfirmationDetails(()=>({message:"",open:val as boolean}))}
                successMethod={successMethodRef.current}
            />
        </div>
    )
}

export default MustBuy